// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,import_extension=js"
// @generated from file agentplatform/httpv2/channel.proto (package infinigence.infini.agentplatform.httpv2, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { ChannelAccount, ChannelAccountBindingMode, ChannelAccountCredential, ChannelType, ChatPolicy } from "../v1/channel_pb.js";
import { file_agentplatform_v1_channel } from "../v1/channel_pb.js";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb.js";
import { file_gnostic_openapi_v3_annotations } from "../../gnostic/openapi/v3/annotations_pb.js";
import { file_google_api_annotations } from "../../google/api/annotations_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file agentplatform/httpv2/channel.proto.
 */
export const file_agentplatform_httpv2_channel: GenFile = /*@__PURE__*/
  fileDesc("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", [file_agentplatform_v1_channel, file_buf_validate_validate, file_gnostic_openapi_v3_annotations, file_google_api_annotations]);

/**
 * BridgeAgentTokenInit 创建 BRIDGE 类型渠道账号时可选携带，指示同时创建一个
 * WEBSOCKET 类型的 AgentToken（绑定到该账号），用于后续 bridge 端接入认证。
 * 仅当 CreateChannelAccountRequest.type == BRIDGE 时生效；其它 channel type 忽略。
 *
 * @generated from message infinigence.infini.agentplatform.httpv2.BridgeAgentTokenInit
 */
export type BridgeAgentTokenInit = Message<"infinigence.infini.agentplatform.httpv2.BridgeAgentTokenInit"> & {
  /**
   * Token 名称（用户可见）/ Token display name
   * @gotags: json:"name"
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * 过期时间戳（unix nano，0 = 永不过期）/ Expire at unix nano (0 = never expires)
   * @gotags: json:"expire_at,omitempty"
   *
   * @generated from field: int64 expire_at = 2 [json_name = "expire_at"];
   */
  expireAt: bigint;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.BridgeAgentTokenInit.
 * Use `create(BridgeAgentTokenInitSchema)` to create a new message.
 */
export const BridgeAgentTokenInitSchema: GenMessage<BridgeAgentTokenInit> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_channel, 0);

/**
 * CreatedBridgeToken 创建成功后返回的 bridge token 明文数据，仅返回一次。
 *
 * @generated from message infinigence.infini.agentplatform.httpv2.CreatedBridgeToken
 */
export type CreatedBridgeToken = Message<"infinigence.infini.agentplatform.httpv2.CreatedBridgeToken"> & {
  /**
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @gotags: json:"name"
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * Token 明文（wst_ 前缀），仅返回一次 / Plaintext token (returned once, keep it safe)
   * @gotags: json:"token"
   *
   * @generated from field: string token = 3;
   */
  token: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.CreatedBridgeToken.
 * Use `create(CreatedBridgeTokenSchema)` to create a new message.
 */
export const CreatedBridgeTokenSchema: GenMessage<CreatedBridgeToken> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_channel, 1);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.CreateChannelAccountRequest
 */
export type CreateChannelAccountRequest = Message<"infinigence.infini.agentplatform.httpv2.CreateChannelAccountRequest"> & {
  /**
   * 资源名称 / Account name
   * @gotags: json:"name"
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * 渠道类型 / Channel type
   * @gotags: json:"type"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.ChannelType type = 2;
   */
  type: ChannelType;

  /**
   * 智能体ID（INSTANCE 模式下为 Application ID，TEMPLATE 模式下为 Agent 模版 ID）
   * @gotags: json:"agent_id"
   *
   * @generated from field: string agent_id = 3 [json_name = "agent_id"];
   */
  agentId: string;

  /**
   * 绑定模式 / Binding mode
   * @gotags: json:"binding_mode,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.ChannelAccountBindingMode binding_mode = 4 [json_name = "binding_mode"];
   */
  bindingMode: ChannelAccountBindingMode;

  /**
   * 渠道账号凭证；BRIDGE 类型可不填 / Credential (optional for BRIDGE)
   * @gotags: json:"credential,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.ChannelAccountCredential credential = 5;
   */
  credential?: ChannelAccountCredential | undefined;

  /**
   * 聊天策略 / Chat policy
   * @gotags: json:"chat_policy,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.ChatPolicy chat_policy = 6 [json_name = "chat_policy"];
   */
  chatPolicy?: ChatPolicy | undefined;

  /**
   * 仅 BRIDGE 类型；若提供则同时创建对应数量的 WEBSOCKET AgentToken 绑定到该账号，明文一次性返回。
   * Bridge-only: if non-empty, atomically creates one WEBSOCKET AgentToken per entry bound to the
   * account; each plaintext is returned once via CreateChannelAccountResponse.bridge_tokens.
   * Empty list means no token is created.
   * @gotags: json:"bridge_tokens,omitempty"
   *
   * @generated from field: repeated infinigence.infini.agentplatform.httpv2.BridgeAgentTokenInit bridge_tokens = 7 [json_name = "bridge_tokens"];
   */
  bridgeTokens: BridgeAgentTokenInit[];
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.CreateChannelAccountRequest.
 * Use `create(CreateChannelAccountRequestSchema)` to create a new message.
 */
export const CreateChannelAccountRequestSchema: GenMessage<CreateChannelAccountRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_channel, 2);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.CreateChannelAccountResponse
 */
export type CreateChannelAccountResponse = Message<"infinigence.infini.agentplatform.httpv2.CreateChannelAccountResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.ChannelAccount data = 4;
   */
  data?: ChannelAccount | undefined;

  /**
   * 若请求中带有 bridge_tokens，此处按对应顺序返回新创建 token 的明文（每条仅一次）
   * @gotags: json:"bridge_tokens,omitempty"
   *
   * @generated from field: repeated infinigence.infini.agentplatform.httpv2.CreatedBridgeToken bridge_tokens = 5 [json_name = "bridge_tokens"];
   */
  bridgeTokens: CreatedBridgeToken[];
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.CreateChannelAccountResponse.
 * Use `create(CreateChannelAccountResponseSchema)` to create a new message.
 */
export const CreateChannelAccountResponseSchema: GenMessage<CreateChannelAccountResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_channel, 3);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.GetChannelAccountRequest
 */
export type GetChannelAccountRequest = Message<"infinigence.infini.agentplatform.httpv2.GetChannelAccountRequest"> & {
  /**
   * 记录 ID / Record ID
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.GetChannelAccountRequest.
 * Use `create(GetChannelAccountRequestSchema)` to create a new message.
 */
export const GetChannelAccountRequestSchema: GenMessage<GetChannelAccountRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_channel, 4);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.GetChannelAccountResponse
 */
export type GetChannelAccountResponse = Message<"infinigence.infini.agentplatform.httpv2.GetChannelAccountResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.ChannelAccount data = 4;
   */
  data?: ChannelAccount | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.GetChannelAccountResponse.
 * Use `create(GetChannelAccountResponseSchema)` to create a new message.
 */
export const GetChannelAccountResponseSchema: GenMessage<GetChannelAccountResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_channel, 5);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.UpdateChannelAccountRequest
 */
export type UpdateChannelAccountRequest = Message<"infinigence.infini.agentplatform.httpv2.UpdateChannelAccountRequest"> & {
  /**
   * 记录 ID / Record ID
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * 新名称（不修改时留空）/ New name (leave empty to keep current)
   * @gotags: json:"name,omitempty"
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * 智能体ID（不修改时留空）/ Agent id (leave empty to keep current)
   * @gotags: json:"agent_id,omitempty"
   *
   * @generated from field: string agent_id = 3 [json_name = "agent_id"];
   */
  agentId: string;

  /**
   * 绑定模式（不修改时留 UNSPECIFIED）/ Binding mode
   * @gotags: json:"binding_mode,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.ChannelAccountBindingMode binding_mode = 4 [json_name = "binding_mode"];
   */
  bindingMode: ChannelAccountBindingMode;

  /**
   * 渠道账号凭证（不修改时留空）/ Credential (nil = keep current)
   * @gotags: json:"credential,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.ChannelAccountCredential credential = 5;
   */
  credential?: ChannelAccountCredential | undefined;

  /**
   * 聊天策略（不修改时留空）/ Chat policy (nil = keep current)
   * @gotags: json:"chat_policy,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.ChatPolicy chat_policy = 6 [json_name = "chat_policy"];
   */
  chatPolicy?: ChatPolicy | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.UpdateChannelAccountRequest.
 * Use `create(UpdateChannelAccountRequestSchema)` to create a new message.
 */
export const UpdateChannelAccountRequestSchema: GenMessage<UpdateChannelAccountRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_channel, 6);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.UpdateChannelAccountResponse
 */
export type UpdateChannelAccountResponse = Message<"infinigence.infini.agentplatform.httpv2.UpdateChannelAccountResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.ChannelAccount data = 4;
   */
  data?: ChannelAccount | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.UpdateChannelAccountResponse.
 * Use `create(UpdateChannelAccountResponseSchema)` to create a new message.
 */
export const UpdateChannelAccountResponseSchema: GenMessage<UpdateChannelAccountResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_channel, 7);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.DeleteChannelAccountRequest
 */
export type DeleteChannelAccountRequest = Message<"infinigence.infini.agentplatform.httpv2.DeleteChannelAccountRequest"> & {
  /**
   * 记录 ID / Record ID
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.DeleteChannelAccountRequest.
 * Use `create(DeleteChannelAccountRequestSchema)` to create a new message.
 */
export const DeleteChannelAccountRequestSchema: GenMessage<DeleteChannelAccountRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_channel, 8);

/**
 * 删除响应无 data 字段 / Delete response has no data field
 *
 * @generated from message infinigence.infini.agentplatform.httpv2.DeleteChannelAccountResponse
 */
export type DeleteChannelAccountResponse = Message<"infinigence.infini.agentplatform.httpv2.DeleteChannelAccountResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.DeleteChannelAccountResponse.
 * Use `create(DeleteChannelAccountResponseSchema)` to create a new message.
 */
export const DeleteChannelAccountResponseSchema: GenMessage<DeleteChannelAccountResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_channel, 9);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ListChannelAccountsRequest
 */
export type ListChannelAccountsRequest = Message<"infinigence.infini.agentplatform.httpv2.ListChannelAccountsRequest"> & {
  /**
   * 分页页码 / Page number
   * @gotags: json:"page,omitempty"
   *
   * @generated from field: int32 page = 1;
   */
  page: number;

  /**
   * 每页大小 / Page size
   * @gotags: json:"page_size,omitempty"
   *
   * @generated from field: int32 page_size = 2 [json_name = "page_size"];
   */
  pageSize: number;

  /**
   * 按渠道类型过滤（可选）/ Filter by channel type (optional)
   * @gotags: json:"type,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.ChannelType type = 3;
   */
  type: ChannelType;

  /**
   * 按 agent_id 过滤（可选）/ Filter by agent id (optional)
   * @gotags: json:"agent_id,omitempty"
   *
   * @generated from field: string agent_id = 4 [json_name = "agent_id"];
   */
  agentId: string;

  /**
   * 按名称模糊搜索（可选）/ Fuzzy name search
   * @gotags: json:"fuzzy_name,omitempty"
   *
   * @generated from field: string fuzzy_name = 5 [json_name = "fuzzy_name"];
   */
  fuzzyName: string;

  /**
   * 按名称或账号 ID 搜索（可选）/ Search by name or account ID.
   * 后端依据 ID 生成规则（"cha-" 前缀）判断输入是 ID 还是名称：
   * 命中前缀走 ID 精确过滤，否则走名称模糊匹配。
   * @gotags: json:"name_or_id,omitempty"
   *
   * @generated from field: string name_or_id = 6 [json_name = "name_or_id"];
   */
  nameOrId: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListChannelAccountsRequest.
 * Use `create(ListChannelAccountsRequestSchema)` to create a new message.
 */
export const ListChannelAccountsRequestSchema: GenMessage<ListChannelAccountsRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_channel, 10);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ListChannelAccountsResponse
 */
export type ListChannelAccountsResponse = Message<"infinigence.infini.agentplatform.httpv2.ListChannelAccountsResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.httpv2.ListChannelAccountsData data = 4;
   */
  data?: ListChannelAccountsData | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListChannelAccountsResponse.
 * Use `create(ListChannelAccountsResponseSchema)` to create a new message.
 */
export const ListChannelAccountsResponseSchema: GenMessage<ListChannelAccountsResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_channel, 11);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.ListChannelAccountsData
 */
export type ListChannelAccountsData = Message<"infinigence.infini.agentplatform.httpv2.ListChannelAccountsData"> & {
  /**
   * @gotags: json:"items"
   *
   * @generated from field: repeated infinigence.infini.agentplatform.v1.ChannelAccount items = 1;
   */
  items: ChannelAccount[];

  /**
   * @gotags: json:"total"
   *
   * @generated from field: int32 total = 2;
   */
  total: number;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.ListChannelAccountsData.
 * Use `create(ListChannelAccountsDataSchema)` to create a new message.
 */
export const ListChannelAccountsDataSchema: GenMessage<ListChannelAccountsData> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_channel, 12);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.EnableChannelAccountRequest
 */
export type EnableChannelAccountRequest = Message<"infinigence.infini.agentplatform.httpv2.EnableChannelAccountRequest"> & {
  /**
   * 记录 ID / Record ID
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.EnableChannelAccountRequest.
 * Use `create(EnableChannelAccountRequestSchema)` to create a new message.
 */
export const EnableChannelAccountRequestSchema: GenMessage<EnableChannelAccountRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_channel, 13);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.EnableChannelAccountResponse
 */
export type EnableChannelAccountResponse = Message<"infinigence.infini.agentplatform.httpv2.EnableChannelAccountResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.ChannelAccount data = 4;
   */
  data?: ChannelAccount | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.EnableChannelAccountResponse.
 * Use `create(EnableChannelAccountResponseSchema)` to create a new message.
 */
export const EnableChannelAccountResponseSchema: GenMessage<EnableChannelAccountResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_channel, 14);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.DisableChannelAccountRequest
 */
export type DisableChannelAccountRequest = Message<"infinigence.infini.agentplatform.httpv2.DisableChannelAccountRequest"> & {
  /**
   * 记录 ID / Record ID
   * @gotags: json:"id"
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.DisableChannelAccountRequest.
 * Use `create(DisableChannelAccountRequestSchema)` to create a new message.
 */
export const DisableChannelAccountRequestSchema: GenMessage<DisableChannelAccountRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_channel, 15);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.DisableChannelAccountResponse
 */
export type DisableChannelAccountResponse = Message<"infinigence.infini.agentplatform.httpv2.DisableChannelAccountResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.ChannelAccount data = 4;
   */
  data?: ChannelAccount | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.DisableChannelAccountResponse.
 * Use `create(DisableChannelAccountResponseSchema)` to create a new message.
 */
export const DisableChannelAccountResponseSchema: GenMessage<DisableChannelAccountResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_channel, 16);

/**
 * 创建/改名前预检：名称在「租户 + 渠道类型」范围内是否唯一。
 *
 * @generated from message infinigence.infini.agentplatform.httpv2.CheckChannelAccountNameRequest
 */
export type CheckChannelAccountNameRequest = Message<"infinigence.infini.agentplatform.httpv2.CheckChannelAccountNameRequest"> & {
  /**
   * 待校验名称 / Name to check
   * @gotags: json:"name"
   *
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * 渠道类型（必填，不能是 UNSPECIFIED）/ Channel type (required)
   * @gotags: json:"type"
   *
   * @generated from field: infinigence.infini.agentplatform.v1.ChannelType type = 2;
   */
  type: ChannelType;

  /**
   * 编辑改名时排除自身账号 ID（可选）/ Exclude self on rename (optional)
   * @gotags: json:"exclude_id,omitempty"
   *
   * @generated from field: string exclude_id = 3 [json_name = "exclude_id"];
   */
  excludeId: string;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.CheckChannelAccountNameRequest.
 * Use `create(CheckChannelAccountNameRequestSchema)` to create a new message.
 */
export const CheckChannelAccountNameRequestSchema: GenMessage<CheckChannelAccountNameRequest> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_channel, 17);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.CheckChannelAccountNameResponse
 */
export type CheckChannelAccountNameResponse = Message<"infinigence.infini.agentplatform.httpv2.CheckChannelAccountNameResponse"> & {
  /**
   * @gotags: json:"code"
   *
   * @generated from field: string code = 1;
   */
  code: string;

  /**
   * @gotags: json:"http_status_code"
   *
   * @generated from field: int32 http_status_code = 2 [json_name = "http_status_code"];
   */
  httpStatusCode: number;

  /**
   * @gotags: json:"success_response"
   *
   * @generated from field: bool success_response = 3 [json_name = "success_response"];
   */
  successResponse: boolean;

  /**
   * @gotags: json:"data,omitempty"
   *
   * @generated from field: infinigence.infini.agentplatform.httpv2.CheckChannelAccountNameData data = 4;
   */
  data?: CheckChannelAccountNameData | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.CheckChannelAccountNameResponse.
 * Use `create(CheckChannelAccountNameResponseSchema)` to create a new message.
 */
export const CheckChannelAccountNameResponseSchema: GenMessage<CheckChannelAccountNameResponse> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_channel, 18);

/**
 * @generated from message infinigence.infini.agentplatform.httpv2.CheckChannelAccountNameData
 */
export type CheckChannelAccountNameData = Message<"infinigence.infini.agentplatform.httpv2.CheckChannelAccountNameData"> & {
  /**
   * 名称在范围内是否可用（true = 未占用）/ Whether the name is available
   * 用 optional 保证显式存在性，protojso 在 false 时也会输出该字段（不省略）。
   * @gotags: json:"available"
   *
   * @generated from field: optional bool available = 1;
   */
  available?: boolean | undefined;
};

/**
 * Describes the message infinigence.infini.agentplatform.httpv2.CheckChannelAccountNameData.
 * Use `create(CheckChannelAccountNameDataSchema)` to create a new message.
 */
export const CheckChannelAccountNameDataSchema: GenMessage<CheckChannelAccountNameData> = /*@__PURE__*/
  messageDesc(file_agentplatform_httpv2_channel, 19);

/**
 * ChannelAccountHTTPV2Service 渠道账号 HTTP V2 服务 / Channel account HTTP V2 service
 *
 * @generated from service infinigence.infini.agentplatform.httpv2.ChannelAccountHTTPV2Service
 */
export const ChannelAccountHTTPV2Service: GenService<{
  /**
   * 创建渠道账号 / Create channel account
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.ChannelAccountHTTPV2Service.CreateChannelAccount
   */
  createChannelAccount: {
    methodKind: "unary";
    input: typeof CreateChannelAccountRequestSchema;
    output: typeof CreateChannelAccountResponseSchema;
  },
  /**
   * 获取渠道账号 / Get channel account / 敏感字段脱敏
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.ChannelAccountHTTPV2Service.GetChannelAccount
   */
  getChannelAccount: {
    methodKind: "unary";
    input: typeof GetChannelAccountRequestSchema;
    output: typeof GetChannelAccountResponseSchema;
  },
  /**
   * 更新渠道账号 / Update channel account
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.ChannelAccountHTTPV2Service.UpdateChannelAccount
   */
  updateChannelAccount: {
    methodKind: "unary";
    input: typeof UpdateChannelAccountRequestSchema;
    output: typeof UpdateChannelAccountResponseSchema;
  },
  /**
   * 删除渠道账号 / Delete channel account
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.ChannelAccountHTTPV2Service.DeleteChannelAccount
   */
  deleteChannelAccount: {
    methodKind: "unary";
    input: typeof DeleteChannelAccountRequestSchema;
    output: typeof DeleteChannelAccountResponseSchema;
  },
  /**
   * 列出渠道账号 / List channel accounts
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.ChannelAccountHTTPV2Service.ListChannelAccounts
   */
  listChannelAccounts: {
    methodKind: "unary";
    input: typeof ListChannelAccountsRequestSchema;
    output: typeof ListChannelAccountsResponseSchema;
  },
  /**
   * 启用渠道账号 / Enable channel account
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.ChannelAccountHTTPV2Service.EnableChannelAccount
   */
  enableChannelAccount: {
    methodKind: "unary";
    input: typeof EnableChannelAccountRequestSchema;
    output: typeof EnableChannelAccountResponseSchema;
  },
  /**
   * 禁用渠道账号 / Disable channel account
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.ChannelAccountHTTPV2Service.DisableChannelAccount
   */
  disableChannelAccount: {
    methodKind: "unary";
    input: typeof DisableChannelAccountRequestSchema;
    output: typeof DisableChannelAccountResponseSchema;
  },
  /**
   * 校验渠道账号名称在「租户 + 渠道类型」范围内是否唯一 / Check channel account name uniqueness
   *
   * @generated from rpc infinigence.infini.agentplatform.httpv2.ChannelAccountHTTPV2Service.CheckChannelAccountName
   */
  checkChannelAccountName: {
    methodKind: "unary";
    input: typeof CheckChannelAccountNameRequestSchema;
    output: typeof CheckChannelAccountNameResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_agentplatform_httpv2_channel, 0);

